export const SWITCH_FACILITY_REQUEST = "SWITCH_FACILITY_REQUEST";
export const SWITCH_FACILITY_FAILURE = "SWITCH_FACILITY_FAILURE";
